import BulletinStore from 'app/store/BulletinStore';

import AuditStore from './AuditStore';
import DialogStore from './DialogStore';
import LicenseStore from './LicenseStore';
import LuceneSearchStore from './LuceneSearchStore';
import NASLStore from './NASLTypesStore';
import ScanWizardStore from './ScanWizardStore';
import SearchStore from './SearchStore';
import StatsStore from './StatsStore';
import UserStore from './UserStore';

export function createStores(dehydratedState) {
    const mobxStores = {};
    const bootstrapPromiseExecutors = [];

    mobxStores.userStore = new UserStore();
    mobxStores.naslStore = new NASLStore();
    mobxStores.auditStore = new AuditStore();
    mobxStores.searchStore = new SearchStore();
    mobxStores.dialogStore = new DialogStore();
    mobxStores.scanWizardStore = new ScanWizardStore();
    mobxStores.licenseStore = new LicenseStore();
    mobxStores.statsStore = new StatsStore(mobxStores.searchStore);
    mobxStores.luceneSearchStore = new LuceneSearchStore();
    mobxStores.bulletinStore = new BulletinStore();

    if (dehydratedState) {
        hydrate(mobxStores, dehydratedState);
    }

    for (const key in mobxStores) {
        const store = mobxStores[key];
        if ('bootstrap' in store && typeof store.bootstrap === 'function') {
            bootstrapPromiseExecutors.push(store.bootstrap.bind(store));
        }
    }

    const bootstrap = () => Promise.allSettled(bootstrapPromiseExecutors.map((execute) => execute()));
    return { mobxStores, bootstrap };
}

export function hydrate(stores, dehydratedState) {
    if (typeof dehydratedState === 'string') {
        dehydratedState = JSON.parse(dehydratedState);
    }
    if (typeof dehydratedState === 'object' && dehydratedState !== null) {
        for (const storeName in dehydratedState) {
            const slice = dehydratedState[storeName];
            if (storeName in stores) {
                const store = stores[storeName];
                if ('hydrate' in store && typeof store.hydrate === 'function') {
                    store.hydrate(slice);
                }
            }
        }
    }
}

export function dehydrate(stores) {
    const dehydratedState = {};

    for (const storeName in stores) {
        const store = stores[storeName];
        if ('dehydrate' in store && typeof store.dehydrate === 'function') {
            dehydratedState[storeName] = store.dehydrate();
        }
    }

    return dehydratedState;
}
